"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgWarningExpired = function SvgWarningExpired(_ref) {
  var props = _extends({}, _ref);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "110",
    height: "100",
    viewBox: "0 0 110 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M86.9434 46.4433V74.3323C86.9434 78.7714 83.3434 82.3698 78.9028 82.3698H33.2684C28.6216 82.3698 24.8559 78.6042 24.8559 73.9558V47.3698C24.8559 46.7495 25.1387 46.1652 25.6262 45.7823L34.4903 38.8027C35.8153 37.7605 37.7591 38.7042 37.7591 40.3917V45.987C37.7591 46.6933 38.1309 47.3495 38.7356 47.7152L53.9591 56.9058C54.5794 57.2823 55.3544 57.2948 55.9872 56.9402L59.3372 55.0683C59.9028 54.7511 60.5872 54.7261 61.1762 54.9995L64.7262 56.6511C65.3294 56.9323 66.0341 56.8964 66.6075 56.5589L85.284 45.4995C86.0169 45.0652 86.9434 45.5933 86.9434 46.4433Z",
      fill: "#EDE6FF"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.9947 67.9722H6.20093C5.33843 67.9722 4.63843 67.2737 4.63843 66.4097C4.63843 65.5456 5.33843 64.8472 6.20093 64.8472H12.9947C13.8587 64.8472 14.5572 65.5456 14.5572 66.4097C14.5572 67.2737 13.8587 67.9722 12.9947 67.9722Z",
      fill: "#EDE6FF"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "60",
      y: "96",
      width: "10",
      height: "4",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M60.072 96.5225H69.9908V99.6473H60.072V96.5225Z",
        fill: "white"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#mask0)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M68.4283 99.6475H61.6345C60.772 99.6475 60.072 98.949 60.072 98.085C60.072 97.2209 60.772 96.5225 61.6345 96.5225H68.4283C69.2923 96.5225 69.9908 97.2209 69.9908 98.085C69.9908 98.949 69.2923 99.6475 68.4283 99.6475Z",
        fill: "#EDE6FF"
      })
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.355 73.25H3.56281C2.70031 73.25 2.00031 72.5516 2.00031 71.6875C2.00031 70.8234 2.70031 70.125 3.56281 70.125H10.355C11.2191 70.125 11.9175 70.8234 11.9175 71.6875C11.9175 72.5516 11.2191 73.25 10.355 73.25Z",
      fill: "#EDE6FF"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "mask1",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "95",
      y: "4",
      width: "12",
      height: "13",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M95.46 4.68799H106.891V16.1175H95.46V4.68799Z",
        fill: "white"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#mask1)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M105.329 8.84111H102.738V6.25049C102.738 5.38643 102.04 4.68799 101.176 4.68799C100.312 4.68799 99.6131 5.38643 99.6131 6.25049V8.84111H97.0225C96.1584 8.84111 95.46 9.53955 95.46 10.4036C95.46 11.2677 96.1584 11.9661 97.0225 11.9661H99.6131V14.5552C99.6131 15.4192 100.312 16.1177 101.176 16.1177C102.04 16.1177 102.738 15.4192 102.738 14.5552V11.9661H105.329C106.193 11.9661 106.891 11.2677 106.891 10.4036C106.891 9.53955 106.193 8.84111 105.329 8.84111Z",
        fill: "#EDE6FF"
      })
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35.9881 75.6945C33.5303 75.6945 31.5303 73.6961 31.5303 71.2367V44.4758L37.3819 48.007C37.4584 48.0555 37.5272 48.1133 37.6131 48.1461L52.6866 57.243L37.2131 69.5805C36.5381 70.1195 36.4272 71.1023 36.9647 71.7758C37.5053 72.4508 38.4866 72.5633 39.16 72.0242L58.5584 56.5586C60.0037 55.407 62.0194 55.4039 63.4678 56.5586L87.2381 75.5102C86.8553 75.618 86.4569 75.6945 86.0381 75.6945H35.9881ZM36.6241 43.8992L32.4006 41.3508L36.6241 38.0258V43.8992ZM82.2772 24.9477V44.9602C82.2772 45.0023 82.2991 45.0383 82.3022 45.0789L66.2412 54.7727L65.4147 54.1133C62.8225 52.0461 59.2006 52.0492 56.6116 54.1133L55.2912 55.1664L39.7491 45.7852V24.9477H82.2772ZM59.0819 20.343C60.2194 19.4508 61.8037 19.4477 62.9444 20.343L64.8241 21.8227H57.2022L59.0819 20.343ZM89.1303 40.9586L85.4022 43.2086V38.0258L89.1303 40.9586ZM68.8475 56.8508L90.4959 43.7852V71.2367C90.4959 72.0945 90.2412 72.8898 89.8194 73.5711L68.8475 56.8508ZM93.0241 40.0477L85.4022 34.0477V23.3852C85.4022 22.5227 84.7037 21.8227 83.8397 21.8227H69.8756L64.8756 17.8867C62.6006 16.0961 59.4225 16.0992 57.1506 17.8867L52.1506 21.8227H38.1866C37.3225 21.8227 36.6241 22.5227 36.6241 23.3852V34.0477L29.0022 40.0477C28.6256 40.3445 28.4053 40.7961 28.4053 41.2758V71.2367C28.4053 75.418 31.8069 78.8195 35.9881 78.8195H86.0381C90.2194 78.8195 93.6209 75.418 93.6209 71.2367V41.2758C93.6209 40.7961 93.4006 40.3445 93.0241 40.0477Z",
      fill: "#6542BE"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M46.4037 35.9058H57.3616C58.2241 35.9058 58.9241 35.2073 58.9241 34.3433C58.9241 33.4792 58.2241 32.7808 57.3616 32.7808H46.4037C45.5397 32.7808 44.8412 33.4792 44.8412 34.3433C44.8412 35.2073 45.5397 35.9058 46.4037 35.9058Z",
      fill: "#6542BE"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M46.4037 43.21H66.4912C67.3553 43.21 68.0537 42.5115 68.0537 41.6475C68.0537 40.7834 67.3553 40.085 66.4912 40.085H46.4037C45.5397 40.085 44.8412 40.7834 44.8412 41.6475C44.8412 42.5115 45.5397 43.21 46.4037 43.21Z",
      fill: "#6542BE"
    })]
  }));
};

var _default = SvgWarningExpired;
exports["default"] = _default;